import localforage from "localforage";
import memoryDriver from "localforage-memoryStorageDriver";
import { setup } from "axios-cache-adapter";

// constants
import { BASE_URL, DEV_URL } from "src/utils/constants";

// `async` wrapper to configure `localforage` and instantiate `axios` with `axios-cache-adapter`
async function configure() {
  // Register the custom `memoryDriver` to `localforage`
  await localforage.defineDriver(memoryDriver);

  // Create `localforage` instance
  const forageStore = localforage.createInstance({
    driver: [
      localforage.INDEXEDDB,
      localforage.LOCALSTORAGE,
      memoryDriver._driver,
    ],
    name: "my-cache",
  });

  // Create `axios` instance with pre-configured `axios-cache-adapter` using a `localforage` store
  return setup({
    // baseURL: BASE_URL,
    baseURL: BASE_URL(),

    // `axios-cache-adapter` options
    cache: {
      maxAge: 15 * 60 * 1000,
      store: forageStore,
      debug: false,
      clearOnStale: true,
      exclude: {
        methods: ["put", "patch", "delete"],
        query: false,
      },
      key: (req) => {
        // need key cause i had same request url but with different body data
        let serialized = JSON.stringify(req.params || "");
        return req.url + serialized;
      },
    },
  });
}

export default configure;
